export const TENANT_ROLE = 'tenant';

export const ROLES = [TENANT_ROLE];
